import { useSearchParams } from 'react-router-dom';
import { PasswordResetCard } from '../components/PasswordResetCard';

export function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  return <PasswordResetCard mode="reset" token={token} />;
}
